<template>
  <v-carousel
    class="w-100"
    :perPage="perPage"
    :autoplay="true"
    :autoplayTimeout="autoplayTimeout"
    :loop="true"
    :speed="speed"
    direction="up"
  >
    <v-slide
      v-for="research in researches"
      :key="research.id"
    >
      <div class="p-2">
        <v-reviewer-research-card
          :research="research"
        />
      </div>
    </v-slide>
  </v-carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import ReviewerResearchCard from '@/reviewer/components/ReviewerResearchCard.vue';

export default {
  name: 'CommercialResearchCarousel',
  props: {
    autoplayTimeout: {
      type: Number,
      default() {
        return 3000;
      },
    },
    researches: {
      required: true,
      type: Array,
    },
    perPage: {
      type: Number,
      default() {
        return 1;
      },
    },
    speed: {
      type: Number,
      default() {
        return 2000;
      },
    },
  },
  components: {
    'v-reviewer-research-card': ReviewerResearchCard,
    'v-carousel': Carousel,
    'v-slide': Slide,
  },
};
</script>
